import { isModuleResourceIdResponseDTO } from "../Module/ModuleResource/ModuleResourceId";
import {
  isStudentProgressEstimateResponseDTO,
  StudentProgressEstimateResponseApi,
} from "../StudentProgress/StudentProgressEstimate";

export interface ModuleResourceWithStudentProgressResponseApi {
  moduleResourceId: string;
  required: boolean;
  order: number;
  resource?: { resourceName: string; resourceCost: number };
  task?: { taskPublicName: string; taskCost: number };
  studentProgress: StudentProgressEstimateResponseApi[];
}

export let isModuleResourceWithStudentProgressResponseDTO = (
  variable: unknown
): variable is ModuleResourceWithStudentProgressResponseApi => {
  return (
    isModuleResourceIdResponseDTO(variable) &&
    "required" in variable &&
    typeof variable.required === "boolean" &&
    "order" in variable &&
    typeof variable.order === "number" &&
    // One - resource or task - must be
    (("resource" in variable &&
      variable.resource !== null &&
      variable.resource !== undefined &&
      typeof variable.resource === "object" &&
      "resourceName" in variable.resource &&
      typeof variable.resource.resourceName === "string" &&
      "resourceCost" in variable.resource &&
      typeof variable.resource.resourceCost === "number") ||
      ("task" in variable &&
        variable.task !== null &&
        variable.task !== undefined &&
        typeof variable.task === "object" &&
        "taskPublicName" in variable.task &&
        typeof variable.task.taskPublicName === "string" &&
        "taskCost" in variable.task &&
        typeof variable.task.taskCost === "number")) &&
    "studentProgress" in variable &&
    Array.isArray(variable.studentProgress) &&
    variable.studentProgress.reduce(
      (doArrayConsistOfProgress, studentProgress: unknown) =>
        doArrayConsistOfProgress &&
        isStudentProgressEstimateResponseDTO(studentProgress),
      true
    )
  );
};
